export const NAMESPACE = "ProfileSectionStore";

const {
  ACCOUNTS,
  CONTACTS
} = require("@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids");

export const TAB_IDS = {
  PROFILE_INFO: "profileInfo",
  EVENT_INFO: "eventInfo"
};
export const TABS = [
  { id: TAB_IDS.PROFILE_INFO, title: "Profile Info" },
  { id: TAB_IDS.EVENT_INFO, title: "Event Info" }
];

export const TAB_INSTANCE_IDS = "profile_tabs_instance_id";

export const FORM_INSTANCE_ID = "profile_form_instance_id";

export const DATE_FORMAT = "M/D [at] h:mma";

export const FIELD_IDS = {
  AVATAR_URL: CONTACTS.AVATAR_URL,
  BIOGRAPHY: CONTACTS.ABOUT,
  SALUTATION: CONTACTS.SALUTATION,
  LAST_NAME: CONTACTS.LAST_NAME,
  FIRST_NAME: CONTACTS.FIRST_NAME,
  HONORIFIC: CONTACTS.HONORIFIC,
  PRONOUNS: CONTACTS.PRONOUNS,
  GENDER: CONTACTS.GENDER,
  TITLE: CONTACTS.TITLE,
  COMPANY: CONTACTS.COMPANY_NAME,
  COMMUNICATION_EMAIL: CONTACTS.EMAIL,
  PHONE_NUMBER: CONTACTS.MOBILE_PHONE,
  LANGUAGES: CONTACTS.LANGUAGES,
  REGION: CONTACTS.GLOBAL_REGION,
  ADDRESS: CONTACTS.ADDRESS_LINE_1,
  ADDRESS_LINE_2: CONTACTS.ADDRESS_LINE_2,
  CITY: CONTACTS.ADDRESS_CITY,
  STATE: CONTACTS.ADDRESS_STATE,
  COUNTRY: CONTACTS.ADDRESS_COUNTRY,
  ZIP: CONTACTS.ADDRESS_ZIP,
  COUNT_OF_EVENTS: "count_of_events",
  SECONDARY_EMAIL: "secondary_email",
  NEW_RETURNING_SPEAKER: "new_returning_speaker",

  LINKEDIN_URL: CONTACTS.LINKEDIN_URL,
  TWITTER_URL: CONTACTS.TWITTER_URL,
  FACEBOOK_URL: CONTACTS.FACEBOOK_URL,
  WEBSITE: CONTACTS.WEBSITE
};

export const FIELD_IDS_ACTIVE_ACCOUNT = {
  LOGO_URL: ACCOUNTS.LOGO_URL,
  GROUP_NAME: ACCOUNTS.NAME,
  DESCRIPTION: ACCOUNTS.DESCRIPTION,
  TIER: ACCOUNTS.TIER,
  PHONE_NUMBER: ACCOUNTS.PHONE,

  LINKEDIN_URL: ACCOUNTS.LINKEDIN_URL,
  TWITTER_URL: ACCOUNTS.TWITTER_URL,
  FACEBOOK_URL: ACCOUNTS.FACEBOOK_URL,
  WEBSITE: ACCOUNTS.WEBSITE
};

export const NEW_RETTURN_OPTIONS = [
  { id: "new", label: "New" },
  { id: "returning", label: "Returning" }
];
